import { issuesForStep, ScoreIssue } from "@signalist/shared-types";

import { ScoreStep } from "./scoreSteps";

export {
	computeScoreIssues,
	criterionIssues,
	issuesForStep,
	issuesFor,
	CRITERION_LABEL_KEYS,
	type ScoreIssue,
	type ScoreIssueKey,
	type ScoreIssueKind,
	type ScoreIssueMessage,
	type ScoreIssueInput,
	type ScoreIssueStep,
} from "@signalist/shared-types";

export type StepStatus = "ok" | "warn" | "none";

const STATUS_STEPS: readonly ScoreStep[] = [
	"overview",
	"general",
	"company",
	"prospect",
	"scoring",
];

/** ok when the step has nothing to fix, warn when it has, none for steps that are never graded. */
export const stepStatus = (issues: ScoreIssue[], step: ScoreStep): StepStatus => {
	if (!STATUS_STEPS.includes(step)) {
		return "none";
	}

	return issuesForStep(issues, step).length > 0 ? "warn" : "ok";
};
